import { createRootRoute, Outlet } from '@tanstack/solid-router'

// Корень дерева. Никакого UI/layout — только <Outlet/>.
// Layout (Rail/Sidebar/Topbar) и DnD/keyboard hooks живут в app-layout.route.tsx.
export const rootRoute = createRootRoute({
  component: () => <Outlet />,
})
